module.exports = __webpack_public_path__ + "static/media/some-javascript-interview-questions.1295d568.jpg";